import { STORAGE_CONST } from '@common/constants'

export const setIsThirdPartyCookieDisabled = () => {
    window.sessionStorage.setItem(STORAGE_CONST.IS_THIRD_PARTY_COOKIE_DISABLED, 'true')
}

export const getIsThirdPartyCookieDisabled = () => {
    return window.sessionStorage.getItem(STORAGE_CONST.IS_THIRD_PARTY_COOKIE_DISABLED) === 'true'
}

export const removeIsThirdPartyCookieDisabled = () => {
    window.sessionStorage.removeItem(STORAGE_CONST.IS_THIRD_PARTY_COOKIE_DISABLED)
}
